<template>
  <div class="nqContent">
    <div class="tiImgBox">
      <swiper
        :options="swiperOptionS"
        class="imgcases"
        ref="mySwiper"
        :slides-per-view="3"
        :space-between="50"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <swiper-slide v-for="(item, i) in swiperList" :key="i">
          <div class="tjBox">
            <div class="tjList">
              <img
                style="cursor:pointer;"
                :src="item.image_path"
                v-if="item.image_path"
              />
              <!-- <el-image style="width:100%;height:100px" :src="item.image_path">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image> -->
              <div class="imgMsg">
                <p>
                  {{ $formatDate(new Date(item.date), "yyyy-MM-dd") }}
                  <!-- {{ arr.date }} -->
                </p>
                <div class="imgYuan"></div>
                <div class="imgLine"></div>
                <!-- <p>
                  数量: {{ item.num }}个
                  <span style="margin-left:6px;">{{ item.growthPhase }}</span>
                </p> -->
                <p>{{ item.wlwName ? item.wlwName : "--" }}</p>
                <!-- <span style="margin-left:6px;">置信度: {{item.score}}</span> -->
              </div>
              <!-- ai识别红框 -->
              <div class="recognise">
                <div
                  class="signDiv"
                  v-for="(it, index) in item.signList"
                  :key="index"
                  :style="{
                    left: it.location.left * w_ratio + 'px',
                    top: it.location.top * h_ratio + 'px',
                    width: it.location.width * w_ratio + 'px',
                    height: it.location.height * h_ratio + 'px',
                  }"
                ></div>
              </div>
            </div>
          </div>
          <!-- {{ item }} -->
        </swiper-slide>
      </swiper>
      <div class="swiper-button-next" @click="swiperNext"></div>
      <div class="swiper-button-prev" @click="swiperPrev"></div>
      <img :src="bchLine" alt="" class="bchLine" />
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getWlwInfoImageSbGroupByDayAndWlwCode } from "@/api/zhwl";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperList: [],
      bchLine: require("@/assets/images/zhwl/bchLine.png"),
      swiperOptionS: {
        autoplay: true,
        slidesPerView: 3, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        spaceBetween: 8,
        loop: true, // 循环轮播
        prevButton: ".swiper-button-prev", // 上一张
        nextButton: ".swiper-button-next", // 下一张
      },
      signList: [],
      h_ratio: 1,
      w_ratio: 1,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      getWlwInfoImageSbGroupByDayAndWlwCode({
        wlwCode: "CJ02A-2110027",
        size: 5,
      }).then((res) => {
        let data = res.data;
        console.log("农情监测 data2 =", res);
        this.swiperList = data.map((item) => {
          item.signList = [];
          if (item.location) {
            // item.signList = JSON.parse(item.location)
            //   ? JSON.parse(item.location).data
            //   : [];
            const locationArr = eval("(" + item.location + ")");
            item.signList = locationArr.data;
          }
          item.image_path = item.url
            ? window.__config.VUE_APP_IMG_URL + item.url
            : require("images/zhwl/not-pic01.png");
          item.num = item.signList.length;
          item.score =
            item.signList.length > 0
              ? (item.signList[0].location.score * 100).toFixed(1) + "%"
              : "0%";
          return item;
          // this.swiperList.push(item);
        });
        console.log(this.swiperList);
        // this.addImg();
      });
    },
    onSlideChange() {},
    onSwiper() {},
    swiperPrev() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    swiperNext() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
    //图片预览
    previewClick(item, index) {
      this.$bus.$emit("previewImg", item, index);
    },
    //识别生成图片
    addImg() {
      //   params;
      this.w_ratio = document.querySelector(".tiImgBox").offsetWidth / 2560;
      this.h_ratio = document.querySelector(".tiImgBox").offsetHeight / 1440;
    },
  },
};
</script>

<style lang="stylus" scoped>
.nqContent
  height 100%
  padding 4px 12px
.tjBox
  width 100%
  height 100%
  display flex
  justify-content space-between

.image-slot
  text-align center
.tjList
  width 100%
  position relative

.tjList img
  height 100px
  object-fit cover
  width 100%

.imgYuan
  width 8px
  height 8px
  background #000
  border 2px solid #00ffff
  border-radius 50%
  margin 0 auto

.imgLine
  width 0
  height 4px
  border 1px #00ffff dotted
  margin 0 auto

.imgMsg
  width 100%
  position absolute
  bottom 3%
  left 50%
  transform translate(-50%, 0)

.tiImgBox
  width 100%
  height 100%
  position relative

.swiper-container
  height 100%

.imgMsg p
  color #fff
  text-align center

.bchLine
  position absolute
  bottom 36px
  left 50%
  transform translate(-50%, 50%)
  width 100%
  z-index 1

.swiper-button-prev, .swiper-button-next
  height 18px

.swiper-button-next
  right 0

.swiper-button-prev
  left 0

.clzsBox, .clzybBox
  height calc(50% - 15px)

.bchTitle
  color #fff
  width max-content
  line-height 2
  background rgb(12, 67, 150)
  border-radius 20px
  padding 0 10px

.recognise
  position absolute
  width 100%
  height 100%
  background-color transparent
  z-index 14
  top 0
  img
    width 100%
    height 100%
.signDiv
  position absolute
  border 1px solid #ff0000
</style>
